import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { FormFieldSkeleton } from '../../../../components/form-field-skeleton/FormFieldSkeleton';
import { ProfilePageHeaderSkeleton } from '../../shared/ProfilePageHeaderSkeleton';
export const EditProfilePageSkeleton: React.FC = () => {
  return (
    <Box>
      <ProfilePageHeaderSkeleton />
      <Grid container spacing={2.5}>
        {_.times(15).map((_item, index) => (
          <Grid key={index} item xs={12} lg={4}>
            <FormFieldSkeleton />
          </Grid>
        ))}
        {_.times(4).map((_item, index) => (
          <Grid key={index} item xs={12} lg={6}>
            <FormFieldSkeleton fieldType="location" />
          </Grid>
        ))}
        {_.times(2).map((_item, index) => (
          <Grid key={index} item>
            <Skeleton variant="rectangular" height="3rem" width="7.5rem" />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
